import styled from '@emotion/styled';
import Link from 'next/link';
import { primaryFontFamily } from '../../styles/fonts';
import { minDeviceWidth } from '../../styles/responsive';
import Button from '../Button';

export const Wrapper = styled.div`
  ${primaryFontFamily}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing(10)};

  @media ${minDeviceWidth('tablet')} {
    padding-top: ${({ theme }) => theme.spacing(6)};
  }
  @media ${minDeviceWidth('desktop')} {
    padding-top: ${({ theme }) => theme.spacing(4)};
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.default.colors.n0};
  width: 100%;

  @media ${minDeviceWidth('tablet')} {
    max-width: 100%;
  }

  @media ${minDeviceWidth('desktop')} {
    max-width: 680px;
    border: 1px solid ${({ theme }) => theme.default.colors.n2};
    border-radius: 4px;
  }
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.secondaryH2}
  padding: 24px 16px;

  @media ${minDeviceWidth('mobile-landscape')} {
    padding: 24px 28px;
  }

  @media ${minDeviceWidth('tablet')} {
    padding: 24px 40px;
  }

  @media ${minDeviceWidth('desktop')} {
    padding: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.default.colors.n2};
  padding: ${({ theme }) => theme.spacing(6, 4)};
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(6)};

  @media ${minDeviceWidth('mobile-landscape')} {
    padding: ${({ theme }) => theme.spacing(6, 7)};
  }

  @media ${minDeviceWidth('tablet')} {
    padding: ${({ theme }) => theme.spacing(6, 10)};
  }

  @media ${minDeviceWidth('desktop')} {
    padding: ${({ theme }) => theme.spacing(6)};
  }
`;

export const Asterisk = styled.span`
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.default.colors.Status.secondaryRed};
`;

export const WrapperSuccess = styled.div`
  margin-top: auto;
  margin-bottom: auto;

  ${primaryFontFamily}
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
`;

export const ContainerSuccess = styled.div`
  background-color: ${({ theme }) => theme.default.colors.n0};
  width: 100%;

  @media ${minDeviceWidth('tablet')} {
    max-width: 100%;
  }

  @media ${minDeviceWidth('desktop')} {
    max-width: 680px;
    border: 1px solid ${({ theme }) => theme.default.colors.n2};
    border-radius: 4px;
  }
`;

export const ContentSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${({ theme }) => theme.spacing(6)};
  text-align: center;
`;

export const TitleSuccess = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const TextSuccess = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.default.colors.n4};
`;

export const FooterSuccess = styled.div`
  padding-top: ${({ theme }) => theme.spacing(10)};
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  row-gap: ${({ theme }) => theme.spacing(6)};

  @media ${minDeviceWidth('mobile-landscape')} {
    flex-direction: row;
  }
`;

export const InlineButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.default.colors.n5};

  &:hover {
    background-color: ${({ theme }) => `${theme.default.colors.n5}16`};
  }

  &:active {
    background-color: ${({ theme }) => `${theme.default.colors.n5}32`};
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

export const StyledButton = styled(Button)`
  width: 100%;

  @media ${minDeviceWidth('mobile-landscape')} {
    width: auto;
  }
`;
